// ─── generateProgramPieces.js ───────────────────────────────────────────
// Refonte écran Suivi — Phase 2 (moteur). Voir docs/PLAN-REFONTE-ECRAN-SUIVI.md.
//
// Le moteur derrière « Générer tout ce qui manque » du module de génération.
// Orchestre la préparation des pièces MANQUANTES qui ne disposent pas de leur
// propre workspace. Ne PERSISTE rien : il
// renvoie les artefacts générés, le composant appelant les sauvegarde via ses
// callbacks habituels (onSave → consultation.intro_letter).
//
// Les menus, recettes, cycle et Meal Prep sont préparés exclusivement dans le
// Dossier application afin de conserver une seule source de vérité.

import { computeProgramCompleteness } from './programCompleteness';
import { generateIntroLetter } from './aiIntroLetter';

/**
 * Prépare les pièces manquantes sans workspace dédié (lettre d'intro).
 *
 * @param {object|null} client
 * @param {object|null} consultation
 * @param {object} [opts]
 * @param {string} [opts.locale='fr']
 * @param {string[]} [opts.only] - restreint la génération à ces pièces (ex.
 *   ['intro'] pour le bouton « Générer » d'une seule ligne). Défaut : tout ce
 *   qui manque.
 * @param {(evt:{piece:string, phase:'start'|'done'|'error'})=>void} [opts.onProgress]
 * @returns {Promise<{
 *   generated: { intro_letter?: object },
 *   ran: string[],
 *   errors: Array<{ piece:string, message:string }>,
 *   completeness: object,
 * }>}
 */
export async function generateMissingProgramPieces(client, consultation, opts = {}) {
  const { onProgress, only } = opts;
  const form = client?.form || {};
  const completeness = computeProgramCompleteness(client, consultation);
  const missing = new Set(completeness.missing || []);
  const onlySet = Array.isArray(only) ? new Set(only) : null;
  // Doit-on générer cette pièce ? Manquante ET (pas de filtre OU dans le filtre).
  const wants = (piece) => missing.has(piece) && (!onlySet || onlySet.has(piece));

  const generated = {};
  const errors = [];
  const ran = [];
  const report = (piece, phase) => {
    if (typeof onProgress === 'function') onProgress({ piece, phase });
  };

  // La lettre d'introduction reste la seule pièce préparée ici.
  if (wants('intro')) {
    report('intro', 'start');
    try {
      generated.intro_letter = await generateIntroLetter({ form, consultation: consultation || {} });
      ran.push('intro');
      report('intro', 'done');
    } catch (e) {
      errors.push({ piece: 'intro', message: e?.message || String(e) });
      report('intro', 'error');
    }
  }

  return { generated, ran, errors, completeness };
}
